module.exports = __webpack_public_path__ + "img/product2.67c3fac9.jpg";